import React, { useState, useEffect } from 'react';

const DatenschutzModal = ({ isOpen, onClose, showAcceptButton = false, onAccept }) => {
  const [privacyContent, setPrivacyContent] = useState('');

  useEffect(() => {
    if (isOpen) {
      // Lade den gespeicherten Inhalt aus localStorage
      const savedContent = localStorage.getItem('privacyContent');
      if (savedContent) {
        setPrivacyContent(savedContent);
      } else {
        // Fallback auf Standard-Inhalt
        setPrivacyContent(`# Datenschutzerklärung

## Verantwortlicher
OK POWER PERSONEN-OBJEKT-WERKSCHUTZ GMBH
Verantwortlich für die Datenverarbeitung auf dieser Website

## Verarbeitete Daten
- E-Mail-Adressen
- Passwörter (verschlüsselt)
- Projektinformationen
- Dienstplan-Daten
- Benutzerrollen und Berechtigungen

## Zweck der Verarbeitung
- Authentifizierung und Autorisierung
- Projektverwaltung
- Dienstplan-Erstellung
- Kommunikation

## Rechtsgrundlage
Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)

## Speicherdauer
- Benutzerdaten: Bis zur Löschung des Accounts
- Projektdaten: Bis zur Projektbeendigung
- Dienstplan-Daten: 7 Jahre (gesetzliche Aufbewahrungspflicht)

## Ihre Rechte
- Auskunft (Art. 15 DSGVO)
- Berichtigung (Art. 16 DSGVO)
- Löschung (Art. 17 DSGVO)
- Einschränkung (Art. 18 DSGVO)
- Datenübertragbarkeit (Art. 20 DSGVO)
- Widerspruch (Art. 21 DSGVO)

## Kontakt
Bei Fragen wenden Sie sich an: datenschutz@power-brandschutz.de`);
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '70vh',
        overflow: 'auto',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          borderBottom: '1px solid #eee',
          paddingBottom: '10px'
        }}>
          <h2 style={{ margin: 0, color: '#2E7D32', fontSize: '20px' }}>
            🛡️ Datenschutzerklärung
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ 
          fontSize: '12px', 
          lineHeight: '1.3',
          whiteSpace: 'pre-line'
        }}>
          {privacyContent.split('\n').map((line, index) => {
            if (line.startsWith('# ')) {
              return <h2 key={index} style={{ color: '#2E7D32', marginBottom: '20px', fontSize: '20px' }}>{line.substring(2)}</h2>;
            } else if (line.startsWith('## ')) {
              return <h3 key={index} style={{ color: '#2E7D32', marginTop: '15px', marginBottom: '8px', fontSize: '15px' }}>{line.substring(3)}</h3>;
            } else if (line.startsWith('- ')) {
              return <li key={index} style={{ marginBottom: '4px', paddingLeft: '20px' }}>{line.substring(2)}</li>;
            } else if (line.trim() === '') {
              return <br key={index} />;
            } else {
              return <p key={index} style={{ marginBottom: '8px' }}>{line}</p>;
            }
          })}
        </div>

        {showAcceptButton && (
          <div style={{
            marginTop: '20px',
            paddingTop: '15px',
            borderTop: '1px solid #eee',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px'
          }}>
            <button
              onClick={onClose}
              style={{
                padding: '8px 16px',
                border: '1px solid #ccc',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                cursor: 'pointer'
              }}
            >
              Schließen
            </button>
            <button
              onClick={onAccept}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#2E7D32',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              ✓ Akzeptieren
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DatenschutzModal;
